export const onlyUnique = (value, index, self) => self.indexOf(value) === index
